export const ENTER_CODE = 13;
export const TAB_CODE = 9;
export const ESC_CODE = 27;

export const ENTER_KEY_NAME = 'Enter';
export const ESCAPE_KEY_NAME = 'Escape';
export const TAB_KEY_NAME = 'Tab';
